export default class AbstractFeatureFlagProvider {
  #priority;

  features;

  static id;

  constructor(providerID, priority, async = false) {
    if (this.constructor === AbstractFeatureFlagProvider) {
      throw new Error('Object of AbstractFeatureFlagProvider Class cannot be created');
    }
    this.constructor.id = providerID;
    this.#priority = priority;
    this.features = new Map();
    this.constructor.async = async;
    this.error = null;
  }

  get priority() {
    return this.#priority;
  }

  isFeatureFlagEnabled(feature) {
    const isEnabled = this.features.get(feature);

    return isEnabled || false;
  }

  hasFeatureFlag(feature) {
    return this.features.has(feature);
  }

  getFeatureFlags() {
    throw new Error(
      `getFeatureFlags function should be implemented in ${this.constructor.name} class`,
    );
  }
}
